<template>
  <!-- Only apply h-screen on desktop. Safari 100vh "bug" -->
  <div class="md:h-screen flex overflow-hidden">
    <mobile-menu :open="mobileMenu" @close="mobileMenu = false">
      <slot name="navigation"></slot>
    </mobile-menu>

    <desktop-menu>
      <slot name="navigation"></slot>
    </desktop-menu>

    <div class="flex flex-col w-0 flex-1 overflow-y-auto">
      <mobile-header @open="mobileMenu = true"></mobile-header>

      <!-- Apply margin because of fixed mobile header -->
      <main
        class="mt-12 md:mt-0 flex-1 relative z-0 pt-4 pb-6 focus:outline-none md:py-6"
        tabindex="0"
      >
        <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
          <slot name="page"></slot>
        </div>
      </main>
    </div>
    <InstantCentralSearch />
  </div>
</template>

<script>
import MobileMenu from "./MobileMenu";
import DesktopMenu from "./DesktopMenu";
import MobileHeader from "./MobileHeader";
import InstantCentralSearch from "../InstantCentralSearch";

export default {
  components: { MobileMenu, DesktopMenu, MobileHeader, InstantCentralSearch },
  data: () => ({ mobileMenu: false }),
};
</script>